import { apiSlice } from '@/store/api/apiSlice';

export interface NextMonthlyPredictionArgs {
  rashi: string;
}

export interface NextMonthlyPredictionResponse {
  prediction: string;
}

export const nextMonthlyPredictionGetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNextMonthlyPrediction: builder.query<
      NextMonthlyPredictionResponse,
      NextMonthlyPredictionArgs
    >({
      query: ({ rashi }) => ({
        url: 'predictions/next-month',
        method: 'GET',
        params: {
          rashi,
        },
      }),
    }),
  }),
});

export const {
  useGetNextMonthlyPredictionQuery,
  useLazyGetNextMonthlyPredictionQuery,
} = nextMonthlyPredictionGetApi;
